import axiosInstance from './axiosInstance';

export const listNotifications = (params = {}) =>
  axiosInstance.get('/notifications', { params }).then((r) => r.data);

export const getNotificationCounts = () =>
  axiosInstance.get('/notifications/counts').then((r) => r.data);

export const markNotificationRead = (id) =>
  axiosInstance.patch(`/notifications/${id}/read`).then((r) => r.data);

export const markAllNotificationsRead = () =>
  axiosInstance.post('/notifications/read-all').then((r) => r.data);

export const getStudentAssignmentAttention = (params = {}) =>
  axiosInstance.get('/notifications/awareness/student/attention', { params }).then((r) => r.data);

export const getFacultyAssignmentInterventions = (params = {}) =>
  axiosInstance.get('/notifications/awareness/faculty/intervention', { params }).then((r) => r.data);
